import { getCompanyVerificationPolicies } from 'services/verificationSettings';

import { createAsyncThunk } from '@reduxjs/toolkit';

export const ThunkGetCompanyPolicies = createAsyncThunk(
  'verificationSettings/getCompanyVerificationPolicies',
  ({ psaId, companyId }: { psaId: number; companyId: number }) =>
    getCompanyVerificationPolicies(psaId, companyId).then(r => r.data),
);
